const fieldErr = {
    TEAM_IDS: 'teamIds',
    OPP_TEAM_IDS: 'oppTeamIds',
    CATEGORY_GAME_IDS: 'gameCateIds',
    DIFF_SCORE: 'diffScore'
}

export default function formErr(data, field) {
    const errors = {};
    field.map(item => {
        if (item === fieldErr.TEAM_IDS) {
            if (data['teamCondition']['team']['central'].length === 0 &&
                data['teamCondition']['team']['pacific'].length === 0 &&
                data['playerCondition']['player'].length === 0) {
                errors[fieldErr.TEAM_IDS] = {message : ' この項目は必須です'};
            }
        }
        if (item === fieldErr.OPP_TEAM_IDS) {
            if (data['teamCondition']['oppTeam']['central'].length === 0 &&
                data['teamCondition']['oppTeam']['pacific'].length === 0 &&
                data['playerCondition']['oppPlayer'].length === 0) {
                errors[fieldErr.OPP_TEAM_IDS] = {message: ' この項目は必須です'};
            }
        }
        if (item === fieldErr.CATEGORY_GAME_IDS) {
            if (data['categorySection'].length === 0) {
                errors[fieldErr.CATEGORY_GAME_IDS] = {message: ' この項目は必須です'};
            }
        }
        if (item === fieldErr.DIFF_SCORE) {
            if (data['pointDifference']['score'] === null) {
                errors[fieldErr.DIFF_SCORE] = {message: ' この項目は必須です'};
            }
        }
    })
    return errors;
}
